import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Avatar,
  Container,
  IconButton,
} from "@mui/material";
import { handleIfLimitCharacter } from "src/shared/Utils/LimitText";
import { formatString } from "@format-string/core";
import { getLinkWhatApp } from "src/Pages/components/CardPlans/CardPlans";
import { WhatsApp } from "@mui/icons-material";
import { ISellerData } from "src/Contexts/LandingPageContext/LandingPagesTypes";
interface NavbarProps {
  sellerData: ISellerData;
}

export const Navbar: React.FC<NavbarProps> = ({ sellerData }) => {
  return (
    <AppBar
      position="sticky"
      sx={{ backgroundColor: "white", boxShadow: "none", py: 1 }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {sellerData?.file?.[0]?.url && (
              <Avatar
                alt={sellerData.name}
                src={sellerData?.file?.[0]?.url}
                sx={{ mr: 1.5, width: 35, height: 35 }}
              />
            )}

            <Box>
              <Typography
                variant="body1"
                sx={{ fontWeight: "bold", color: "text.primary" }}
              >
                {handleIfLimitCharacter({ LIMIT: 40, value: sellerData?.name })}
              </Typography>

              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box
                  component="a"
                  href={getLinkWhatApp(
                    `55${sellerData?.phone1}`,
                    `Olá, me chamo ${sellerData?.name}, tenho uma dúvida: .`
                  )}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    textDecoration: "none",
                  }}
                  target="_blank"
                >
                  <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    {formatString({
                      value: sellerData?.phone1 || "",
                      type: "phone",
                    })}
                  </Typography>
                  <IconButton>
                    <WhatsApp color="success" fontSize="small" />
                  </IconButton>
                </Box>
              </Box>
            </Box>
          </Box>

          <Button
            variant="contained"
            href="#contact-form" // Link para a seção do formulário
            sx={{
              backgroundColor: "#34D399", // Cor verde similar à da imagem
              color: "white",
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: "bold",
              px: 3,
              py: 1,
              "&:hover": {
                backgroundColor: "#10B981", // Verde um pouco mais escuro no hover
              },
            }}
            size={"small"}
          >
            Falar agora
          </Button>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
